import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import i18n from "i18n";
import { TagService } from "services/TagService";

import AdminLayout from "components/MainApp/layouts/DesktopLayout";
import Loader from "components/MainApp/atoms/Loader";
import GenericErrorModal from "components/MainApp/atoms/Modals/GenericErrorModal";
import TogglePnlTemplateTag from "./TogglePnlTemplateTag";

import styles from "./TagDetail.module.scss";
import { isMobile } from "helpers/Mobile";
import { capitalize } from "helpers/utils/utils_general";

const ConfigTagDetailView = (props) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const [configTag, setConfigTag] = useState(null);

  useEffect(() => {
    if (!props.match.params.key) return;
    const id = props.match.params.key;
    setLoading(true);
    TagService.configTag(id).then((configTag) => {
      setConfigTag(configTag);
      setLoading(false);
    });
  }, []);

  const headerOptionsIcons = [
    {
      icon: "edit_code_template",
      name: "edit_code_template",
      handler: () => {
        history.push(`/admin/code_tags/edit/${configTag.id}`);
      },
      tooltip: i18n.t("edit.template.code")
    }
  ];

  const headerOptions = [];

  const handleGoBack = () => {
    history.push(`/admin/config_tags`);
  };

  const content = (
    <div className={styles["businessnode-detail-content-wrapper"]}>
      {configTag && (
        <TogglePnlTemplateTag
          itemTplTag ={configTag}
        />
      )}
    </div>
  );
  return (
    <div className={styles["businessnode-detail-container"]}>
      <AdminLayout
        headerTitle={i18n.t("template.detail")}
        headerOptions={headerOptions}
        headerOptionsIcons={headerOptionsIcons}
        content={content}
        navHidden={true}
        goBackFunc={handleGoBack}
      ></AdminLayout>

      {loading && <Loader />}
    </div>
  );
};

export default ConfigTagDetailView;
